import { URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

interface ItemDetail {
  code: (string | null)[];
  description: (string | null)[];
  name: (string | null)[];
}

type CommonCodesResponse = Record<string, ItemDetail>;

export const fetchCommonCodes = async (params = ''): Promise<CommonCodesResponse> => {
  const url = `${URLS.BACK_DSH}/common/common-codes${params ? `?${params}` : ''}`;
  return await request.get(url);
};

export interface CommonCodeSearchItem {
  code: string;
  name: string;
}

export interface CommonCodeSearchData {
  // Every match, not just the returned page - it is what tells the caller
  // whether what it got is the whole answer.
  total_count: number;
  list: CommonCodeSearchItem[];
}

/**
 * One page of a cm_code group, filtered by keyword.
 *
 * The paged counterpart to `fetchCommonCodes`, which returns whole groups.
 * Group 'ICD10' alone is ~18,500 diagnoses - about a megabyte of JSON nobody
 * scrolls - so a picker loads a first page and searches from there.
 */
export const searchCommonCodes = async (
  upperCode: string,
  keyword = '',
  limit = 50
): Promise<CommonCodeSearchData> => {
  const params = new URLSearchParams({ 'upper-code': upperCode, limit: String(limit) });
  if (keyword) params.set('keyword', keyword);

  const response = await request.get<{ data: CommonCodeSearchData | null }>(
    `${URLS.BACK_DSH}/common/common-codes/search?${params.toString()}`
  );
  return response?.data ?? { total_count: 0, list: [] };
};
